/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RoundingDirections {
    Up = 10,
    Down = 20,
    Nearest = 30,
}
